module.exports = __webpack_public_path__ + "static/media/icon-filledP.4d183451.svg";